import { DELIVERY_TYPE } from '@/lib/Constants';
import { getCities } from '@/lib/SettingsStorage';
import { WebLink } from '@/lib/WebLinks';
import { Basket } from '@/models/Basket';
import { PRODUCT_TYPE } from '@/models/Product';

/** Araç süsleme sepeti checkout’a doğrudan fatura adımından girer */
export const CHECKOUT_DECORATION_START_PATH = '/satin-al-fatura-bilgileri';

export function getCheckoutStartPath(basket?: Basket): string {
  return isDecorationDeliveryBasket(basket) ? CHECKOUT_DECORATION_START_PATH : WebLink.CHECKOUT;
}

/** Randevu (araç süsleme) akışı — CTA ve tarih etiketleri */
export const APPOINTMENT_PRIMARY_CTA = 'Randevu Al';

export function isDecorationDeliveryBasket(basket?: Basket): boolean {
  if (basket?.deliveryType !== undefined && basket?.deliveryType !== null) {
    return Number(basket.deliveryType) === DELIVERY_TYPE.DECORATION;
  }
  return basket?.items?.[0]?.productTypeId === PRODUCT_TYPE.VEHICLE_DECORATION;
}

/** @deprecated isDecorationDeliveryBasket kullanın; deliveryType önceliklidir */
export function isVehicleDecorationBasket(basket?: Basket): boolean {
  return isDecorationDeliveryBasket(basket);
}

/** Satır değeri Kargo iken sabit; aksi halde randevu / teslimat tarihi etiketi */
export function deliveryDateFieldLabel(
  isAppointmentFlow: boolean,
  deliveryDateDisplay: string,
): string {
  if (deliveryDateDisplay === 'Kargo') {
    return 'Teslimat Tipi';
  }
  return isAppointmentFlow ? 'Randevu Tarihi' : 'Teslimat Tarihi';
}

export function getCityTitleForDistrict(cityId?: number): string | undefined {
  if (!cityId) return undefined;
  const city = getCities().find((item) => item.id === cityId);
  if (!city?.title) return undefined;
  return city.title.split(' ')[0];
}

export function formatBasketDeliveryRegion(basket?: Basket): string {
  if (!basket?.district?.title) return '-';
  const cityTitle = getCityTitleForDistrict(basket.district.cityId);
  return cityTitle ? `${cityTitle} — ${basket.district.title}` : basket.district.title;
}

export function normalizeProductUrl(url?: string, fallback = WebLink.PRODUCTS): string {
  if (!url?.trim()) return fallback;
  const trimmed = url.trim();
  if (trimmed.startsWith('http://') || trimmed.startsWith('https://')) {
    try {
      return new URL(trimmed).pathname + new URL(trimmed).search;
    } catch {
      return fallback;
    }
  }
  return trimmed.startsWith('/') ? trimmed : `/${trimmed}`;
}
